import { z } from 'zod';

export const validateSearch = z.object({
  categoryId: z.uuid().optional(),
});
